import { Row } from "@tanstack/react-table";

import { PostalCodeWithAgencyType } from "@/codegen/openapi2";

import { AgencySelector } from "./agency-selector";

type AgencyCellProps = {
  row: Row<PostalCodeWithAgencyType>;
  handleUpsert?: (
    row: PostalCodeWithAgencyType,
    agencyUuid: string,
    coreAgency: boolean | null,
    closeCoreAgency: boolean | null
  ) => void;
  handleDelete?: (row: PostalCodeWithAgencyType) => void;
};

export const AgencyCell = ({ row, handleUpsert, handleDelete }: AgencyCellProps) => {
  const onChange =
    handleUpsert && handleDelete
      ? (agencyUuid: string | null) => {
          if (!agencyUuid) {
            handleDelete(row.original);
          } else {
            handleUpsert(
              row.original,
              agencyUuid,
              row.original.core_agency,
              row.original.close_core_agency
            );
          }
        }
      : undefined;

  return (
    <AgencySelector
      legalEntity={row.original.legal_entity_uuid}
      selectedAgency={row.original.agency_uuid}
      onChange={onChange}
    />
  );
};
